var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-page',[_c('main',{staticClass:"nf-page"},[_c('section',[_c('p',[_vm._v("404")]),_c('h1',[_vm._v("NOT THIS WAY.")]),_c('p',{staticClass:"nf-copy"},[_vm._v("찾으시는 페이지가 없어요.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("BACK TO MUZIN "),_c('span',[_vm._v("↗")])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }